import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

const swiper = new Swiper(".js-homeSwiper", {
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  },
  centeredSlides: true,
  loop: true,
  pagination: {
    clickable: true,
    el: ".js-homeSwiper .swiper-pagination",
  },
  slidesPerView: "auto",
  spaceBetween: 0,
});
